import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { getBaseURL } from '../services/api';

const SID_KEY = 'fz_sid';
const LAST_PATH_KEY = 'fz_last_path';

function getSessionId() {
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `s${Date.now()}${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

// Dispara pageview no mount + toda mudanca de rota. Dedup por path
// (evita duplicar quando componente re-renderiza sem mudar URL).
// Silencioso, best-effort. So roda no hostname comunidade.
export default function useTrackPageview(extraEventType) {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.location.hostname.startsWith('comunidade.')) return;
    const path = location.pathname;
    const lastPath = sessionStorage.getItem(LAST_PATH_KEY);
    if (lastPath === path && !extraEventType) return;
    sessionStorage.setItem(LAST_PATH_KEY, path);
    let cpId = null;
    try {
      const user = JSON.parse(localStorage.getItem('community_user') || 'null');
      cpId = user?.id || null;
    } catch { /* ignore */ }
    axios.post(`${getBaseURL()}/community/analytics/track`, {
      event_type: extraEventType || 'pageview',
      path,
      session_id: getSessionId(),
      cp_id: cpId,
      referrer: document.referrer || null,
    }).catch(() => {}); // best-effort
  }, [location.pathname, extraEventType]);
}

// Track ad-hoc (ex: signup completo). Nao depende de useLocation.
export function trackEvent(eventType, extra = {}) {
  if (typeof window === 'undefined') return;
  if (!window.location.hostname.startsWith('comunidade.')) return;
  let cpId = extra.cp_id || null;
  if (!cpId) {
    try {
      const user = JSON.parse(localStorage.getItem('community_user') || 'null');
      cpId = user?.id || null;
    } catch { /* ignore */ }
  }
  axios.post(`${getBaseURL()}/community/analytics/track`, {
    event_type: eventType,
    path: window.location.pathname,
    session_id: getSessionId(),
    cp_id: cpId,
    referrer: document.referrer || null,
  }).catch(() => {});
}
